import { render, staticRenderFns } from "./PortabilityDetailsLoader.vue?vue&type=template&id=1d940420&scoped=true"
import script from "./PortabilityDetailsLoader.vue?vue&type=script&setup=true&lang=ts"
export * from "./PortabilityDetailsLoader.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PortabilityDetailsLoader.vue?vue&type=style&index=0&id=1d940420&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d940420",
  null
  
)

export default component.exports